<template>
  <!-- The planner's warnings button: a round map control the size and style of
       the location button beside it (MapControls `map-btn`), with just the
       map buttons' white warning glyph (half the circle, centred by map-btn's
       flex box) and a notification-style count badge on its top-right. Only
       there while the route has warnings. -->
  <button
    v-if="count > 0"
    type="button"
    class="map-btn route-alerts-button"
    data-test="route-alerts-button"
    :aria-label="a11yLabel"
    :title="a11yLabel"
    :aria-expanded="expanded ? 'true' : 'false'"
    @click="$emit('open')"
  >
    <span class="material-icons route-alerts-button__icon" aria-hidden="true">warning</span>
    <span class="route-alerts-button__badge" aria-hidden="true" data-test="route-alerts-badge">{{ badge }}</span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { alertsButtonA11yLabel, badgeText } from '../../../utils/routeAlerts/routeAlertsModel';

export default defineComponent({
  name: 'RouteAlertsButton',
  props: {
    count: { type: Number, default: 0 },
    /** The sheet it opens is showing. */
    expanded: { type: Boolean, default: false },
  },
  emits: ['open'],
  computed: {
    badge(): string {
      return badgeText(this.count);
    },
    a11yLabel(): string {
      return alertsButtonA11yLabel(this.count, (key, values) => this.$t(key, values ?? {}) as string);
    },
  },
});
</script>

<style scoped>
/* The location button's box (32 px, dark, shadow), made round. */
.map-btn.route-alerts-button {
  position: relative;
  border-radius: 50%;
}

/* The map buttons' white (map-btn's colour), half the 32 px circle, centred by
   map-btn's flex box. Twins: Android ICON_FRACTION 0.5, iOS iconSize 22.5 of 45 pt. */
.route-alerts-button__icon {
  font-size: 16px;
  line-height: 1;
}

/* Small red disc on the top-right of the circle, like an app-icon badge. */
.route-alerts-button__badge {
  position: absolute;
  top: -5px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #db2b35;
  color: #fff;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  box-shadow: 0 0 0 1.5px rgba(17, 17, 17, 0.9);
  pointer-events: none;
}
</style>
